import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CouponsComponent } from './coupons.component';
import { ListModule } from './list/index';
import { EditModule } from './edit';

const ROUTES: Routes = [
  {
    path: 'coupons',
    component: CouponsComponent,
    loadChildren: (): any => ListModule,
    pathMatch: 'full',
  },
  {
    path: 'coupons/:id/edit',
    component: CouponsComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
  {
    path: 'coupons/new',
    component: CouponsComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
];

@NgModule({ imports: [
  RouterModule.forChild(ROUTES),
],
declarations: [CouponsComponent],
exports: [CouponsComponent] })
export class CouponsModule {}
